import {
	RESET_STATE,
	SET_ICEPACKS_FILLED,
	SET_ICEPACKS_FILLERS,
	SET_ICEPACKS_STATES,
	SET_IS_ICEPACKS_FILLED_LOADING,
	SET_IS_ICEPACKS_FILLERS_LOADING,
	SET_IS_ICEPACKS_STATES_LOADING,
	SET_PAGINATION,
	SET_MODES,
	SET_IS_MODES_LOADING,
} from './actions';

export const initialState = {
	icepacksFilled: [],
	isIcepacksFilledLoading: false,
	pagination: null,
	icepacksFillers: [],
	isIcepacksFillersLoading: false,
	icepacksStates: [],
	isIcepacksStatesLoading: false,
	modes: [],
	isModesLoading: false,
};

const icepacksFilledContainerReducer = (state = initialState, action) => {
	const { type, payload } = action;
	switch (type) {
		case SET_ICEPACKS_FILLED:
			return {
				...state,
				icepacksFilled: payload,
			};
		case SET_IS_ICEPACKS_FILLED_LOADING:
			return {
				...state,
				isIcepacksFilledLoading: payload,
			};
		case SET_PAGINATION:
			return {
				...state,
				pagination: payload,
			};
		case SET_ICEPACKS_FILLERS:
			return { ...state, icepacksFillers: payload };
		case SET_IS_ICEPACKS_FILLERS_LOADING:
			return { ...state, isIcepacksFillersLoading: payload };
		case SET_ICEPACKS_STATES:
			return { ...state, icepacksStates: payload };
		case SET_IS_ICEPACKS_STATES_LOADING:
			return { ...state, isIcepacksStatesLoading: payload };
		case SET_MODES:
			return { ...state, modes: payload };
		case SET_IS_MODES_LOADING:
			return { ...state, isModesLoading: payload };
		case RESET_STATE:
			return initialState;
		default:
			return state;
	}
};

export default icepacksFilledContainerReducer;
